/* eslint-disable max-lines */
import {
  agenHistory,
  deactivateTransactionManual,
  editMerchant,
  identityImage,
  putBlockPinMerchant,
  resendMerchant,
  settingMerchantDetail,
  settingMerchantList,
  settingMerchantSearch,
  suspendMerchant,
  syncMerchantMonica,
  transactionManualHistory,
  unsuspendMerchant,
  updateAgen,
  validateBank
} from '../../utils/api';
import { filterBuilder } from '../../utils/builder/settingDataMerchant';
import { actionTypes } from './constants';
import { initialState } from './reducer';

export function setFailedAction({ key, message, error, data, code }) {
  return { type: actionTypes.FAILED, key, message, error, data, code };
}

export function setLoadingAction({ key, loading = true }) {
  return { type: actionTypes.LOADING, key, loading };
}

export function setResetAction() {
  return { type: actionTypes.RESET };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
  success = true,
  code = 200,
}) {
  return { type: actionTypes.SUCCESS, key, data, meta, initial, message, success, code };
}

export function setFilterAction({ key, filter = {} }) {
  return { type: actionTypes.FILTER, key, filter };
}

export function setMessageAction({ key, message }) {
  return { type: actionTypes.MESSAGE, key, message };
}

export function setFormAction({ key, form }) {
  return { type: actionTypes.FORM, key, form };
}

export function fetchSettingMerchantList({
  nextPage = 1,
  search = '',
  filter = initialState.table.filter,
  initial = true,
}) {
  return async (dispatch, getState) => {
    const key = 'table';
    const state = getState();
    const { page, totalPage } = state.merchantSetting[key].meta;
    if (!initial && page > 1 && page >= totalPage) {
      return;
    } else {
      try {
        const params = {
          ...filter,
          search,
          size: 100,
          page: nextPage,
        };
        dispatch(setLoadingAction({ key }));
        const response = await settingMerchantList(filterBuilder(params));
        const data = initial
          ? response.data
          : [...state.merchantSetting[key].data, ...response.data];
        dispatch(setSuccessAction({ key, data, meta: response.meta, initial }));
        dispatch(setFailedAction({ key: 'resend', message: '', error: {} }));
        dispatch(clearRedux());
      } catch (error) {
        const { message } = error;
        dispatch(setFailedAction({ key, message }));
      }
    }
  };
}

export function setSettingMerchantListFilter(filter) {
  return async (dispatch) => {
    dispatch(
      setFilterAction({
        key: 'table',
        filter,
      })
    );
  };
}

export function fetchSearchSettingMerchant(params) {
  return async (dispatch) => {
    const key = 'search';
    try {
      dispatch(setLoadingAction({ key }));
      const body = {
        ...params,
        search: params.search.trim(' ') || '',
      };

      const { data, code } = await settingMerchantSearch(body);
      dispatch(setSuccessAction({ key, data, code }));
    } catch (error) {
      const { message, code } = error;
      dispatch(setFailedAction({ key, message, code }));
    }
  };
}

export function fetchSettingMerchantDetail(id = '', plantext = false) {
  return async (dispatch) => {
    const key = 'detail';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await settingMerchantDetail(id, plantext);
      dispatch(setSuccessAction({ key, data }));
      dispatch(clearRedux());
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function fetchSyncMerchant(id) {
  return async (dispatch) => {
    const key = 'sync';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await syncMerchantMonica(id);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message, data } = error;
      dispatch(setFailedAction({ key, message, data }));
    }
  };
}
export function fetchAgenHistory(id, params) {
  return async (dispatch) => {
    const key = 'agenHistory';
    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await agenHistory(id, params);
      dispatch(setSuccessAction({ key, data }));
      dispatch(clearRedux());
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export const clearRedux = () => {
  return async (dispatch) => {
    dispatch(setSuccessAction({ key: 'bank', data: {}, message: '' }));
    dispatch(setSuccessAction({ key: 'agen', data: {}, message: '' }));
    dispatch(setSuccessAction({ key: 'search', data: null, message: '', code: 200 }));
    dispatch(setFailedAction({ key: 'agen', message: '' }));
    dispatch(setFailedAction({ key: 'identity', message: '' }));
    dispatch(setFailedAction({ key: 'sync', message: '' }));
  };
};

export const ResetRedux = () => {
  return async (dispatch) => {
    dispatch(setResetAction());
  };
};

export function fetchUpdateAgen(id, payload) {
  return async (dispatch) => {
    const key = 'agen';
    try {
      dispatch(setLoadingAction({ key }));
      const { success, message } = await updateAgen(id, payload);
      dispatch(
        setSuccessAction({
          key,
          data: success,
          message: message,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function createSuspendMerchant({ id, payload }) {
  return async (dispatch, getState) => {
    const state = getState();
    const key = 'suspend';
    try {
      const { storeName } = state.merchantSetting.detail.data;
      dispatch(setLoadingAction({ key }));
      const { success } = await suspendMerchant(id, payload);
      dispatch(
        setSuccessAction({
          key,
          data: success,
          message: `Berhasil melakukan suspend untuk <strong>${storeName}</strong>`,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}


export function identityImageUpload(id, payload) {
  return async (dispatch) => {
    const key = 'identity';
    try {
      dispatch(setLoadingAction({ key }));
      const data = await identityImage(id, { identityImage: payload });
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      dispatch(setFailedAction({ key, message: error?.message }));
    }
  };
}
export function openSuspendMerchant({ id, payload }) {
  return async (dispatch, getState) => {
    const state = getState();
    const key = 'suspend';
    try {
      const { storeName } = state.merchantSetting.detail.data;
      dispatch(setLoadingAction({ key }));
      const { success } = await unsuspendMerchant(id, payload);
      dispatch(
        setSuccessAction({
          key,
          data: success,
          message: `Berhasil melakukan buka suspend untuk <strong>${storeName}</strong>.`,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function blockPinMerchant({ id }) {
  return async (dispatch, getState) => {
    const state = getState();
    const key = 'blockPin';
    try {
      const { storeName } = state.merchantSetting.detail.data;
      dispatch(setLoadingAction({ key }));
      const { success } = await putBlockPinMerchant(id);
      dispatch(
        setSuccessAction({
          key,
          data: success,
          message: `Berhasil Blokir PIN Pangkalan <strong>${storeName}</strong>.`,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function validateBankAccount(params) {
  return async (dispatch) => {
    const key = 'bank';

    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await validateBank(params);
      if (!data.isValid) {
        throw new Error(data.message);
      }
      dispatch(
        setSuccessAction({
          key,
          data: { ...data, isChecked: true },
          message: data.message,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
      dispatch(
        setSuccessAction({
          key,
          data: { isChecked: true, isValid: false },
          message,
          success: false
        })
      );
    }
  };
}

export function updateMerchant({ id, payload }) {
  return async (dispatch, getState) => {
    const state = getState();
    const key = 'edit';

    try {
      const { storeName } = state.merchantSetting.detail.data;
      dispatch(setLoadingAction({ key }));
      const { data } = await editMerchant(id, payload);
      dispatch(
        setSuccessAction({
          key,
          data,
          message: `Berhasil merubah data <strong>${storeName}</strong>`,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function resendMerchantAccount(id) {
  return async (dispatch, getState) => {
    const state = getState();
    const key = 'resend';
    try {
      const { storeName } = state.merchantSetting.detail.data;
      dispatch(setLoadingAction({ key }));
      const { data } = await resendMerchant(id);
      dispatch(
        setSuccessAction({
          key,
          data,
          message: `Berhasil mengirim ulang akun <strong>${storeName || ''}</strong>`,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message, error }));
    }
  };
}

export function fetchTransactionManualList({ nextPage = 1, initial = true }) {
  return async (dispatch, getState) => {
    const key = 'transactionManual';
    const state = getState();
    const { page, totalPage } = state.merchantSetting[key].meta;
    const { userId } = state.merchantSetting.detail.data;
    if (!initial && page > 1 && page >= totalPage) {
      return;
    }
    try {
      dispatch(setLoadingAction({ key }));
      const params = { size: 100, page: nextPage };
      const { data, meta = state.merchantSetting[key].meta } =
        await transactionManualHistory(userId, params);
      dispatch(
        setSuccessAction({ key, data, meta, initial })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function turnOffTransactionManual() {
  return async (dispatch, getState) => {
    const state = getState();
    const key = 'deactivate';
    try {
      const { storeName, userId } = state.merchantSetting.detail.data;
      dispatch(setLoadingAction({ key }));
      const { success } = await deactivateTransactionManual({ userId });
      dispatch(
        setSuccessAction({
          key,
          data: success,
          message: `Berhasil menonaktifkan pencatatan manual untuk <strong>${storeName}</strong>`,
        })
      );
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}
